import { Injectable, Injector } from '@angular/core';
import { CalendarEvent } from '../entities/calendar-event';
import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { LazyLoadEvent } from 'primeng/primeng';
import { HttpErrorResponse, HttpParams } from '@angular/common/http';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { AttendanceHead } from '../entities/attendance-head';
import { Observable } from 'rxjs/Observable';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';
import { catchError, tap } from 'rxjs/operators';
import { AttendanceCalculation } from '../model/attendance-calculation';
import { Mhelpdesk } from '../entities/mhelpdesk';

@Injectable()
export class CalendarEventService extends BaseCrudService<CalendarEvent> {

  public uri = '/api/calendarEvent';

  constructor(injector: Injector) {
    super(injector);
    //console.log('Instance CalendarEventService');
  }

  buildSentence(entity?: CalendarEvent, event?: LazyLoadEvent, extraQueryCondition?: string): HttpParams {
    if (entity) {
      let query = '';
      if (extraQueryCondition) {
        query = query.concat(extraQueryCondition);
      }
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  buildSentenceToAttendance(entity?: AttendanceHead, event?: LazyLoadEvent, extraQueryCondition?: string): HttpParams {
    if (entity) {
      let query = '';
      query = query.concat(
        entity.employee && entity.employee.id ?
          `employee.id${QueryOperator.Equal}${entity.employee.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.fiscalYear && entity.fiscalYear.id ?
          `fiscalYear.id${QueryOperator.Equal}${entity.fiscalYear.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.fiscalYear && entity.fiscalYear.code ?
          `fiscalYear.code${QueryOperator.Equal}${entity.fiscalYear.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month && entity.month.id ?
          `month.id${QueryOperator.Equal}${entity.month.id}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        entity.month && entity.month.code ?
          `month.code${QueryOperator.Equal}${entity.month.code}${QueryOperator.Split}`
          : QueryOperator.Empty
      );
      query = query.concat(
        extraQueryCondition ? extraQueryCondition : QueryOperator.Empty
      );
      //console.log(query);
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  searchByAttendance(entity?: AttendanceHead, event?: LazyLoadEvent): Observable<CalendarEvent[]> {
    const url = `
      ${this.rutaServidor}${this.uri}/attendance/employee/${entity.employee.id}/year/${entity.fiscalYear.code}/month/${entity.month.code}/language/${entity.language}/euId/${entity.executingUnit.id}
    `;
    this.spinnerService.showAll();
    return this.httpClient.get<CalendarEvent[]>(url)
      .pipe(
        tap(response => {
          //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  downloadAttendanceRecordReport(entity?: AttendanceHead): Observable<any> {
    //console.log('downloadAttendanceStubReport');
    // tslint:disable-next-line:max-line-length
    const url = `${this.rutaServidor}${this.uri}/attendance/employee/${entity.employee.id}/year/${entity.fiscalYear.code}/month/${entity.month.code}/report/attendance-record/${entity.language}`;
    this.spinnerService.showAll();
    return this.httpClient.get(url, { responseType: 'blob' })
      .pipe(
        tap(response => {
          //console.log('dowloadAttendanceReport');
          //console.log(response);
          this.spinnerService.hideAll();
        })
         ,
          catchError(error=>{  
              this.spinnerService.hideAll();
              console.log("catchError",error)
              // const message = (error?.error?.messages[0]) || 'Error inesperado';
              // this.notificationService.smallBoxError(error.error.messages[0]); 
              if (error.status === 400 || error.status === 500) {
                //return throw(() => new Error(error.error ? error.error.message : 'Error desconocido'));
                 this.notificationService.smallBoxError("No existen datos");
              }else {
                this.notificationService.smallBoxError("No existen datos");
              }
              return Observable.throw(entity);
            })
      );
  }


  searchByPayrollAmount(entity?: AttendanceHead, event?: LazyLoadEvent): Observable<CalendarEvent[]> {
    const url = `${this.rutaServidor}${this.uri}/payrollAmount/employee/${entity.employee.id}/year/${entity.fiscalYear.code}/month/${entity.month.code}`;
    this.spinnerService.showAll();
    return this.httpClient.get<CalendarEvent[]>(url)
      .pipe(
        tap(response => {
          //console.log(response);
          this.spinnerService.hideAll();
          return response;
        })
      );
  }

  attendanceCalculation(attendanceCalculationField: AttendanceCalculation) {
    const url = `${this.rutaServidor}${this.uri}/attendanceCalculation/`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set(QueryOperator.Action, attendanceCalculationField.type);
    return this.httpClient.post<AttendanceCalculation>(url, attendanceCalculationField, { params: this.httpParams })
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
        })
      );
  }

  attendanceCalculationGroup(attendanceCalculationField: AttendanceCalculation) {
    const url = `${this.rutaServidor}${this.uri}/attendanceCalculationGroup/`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set(QueryOperator.Action, attendanceCalculationField.type);
    return this.httpClient.post<AttendanceCalculation>(url, attendanceCalculationField, { params: this.httpParams })
      .pipe(
        tap(response => {
          this.spinnerService.hideAll();
        })
      );
  }

  searchLanguage(employeeId: number) {
    const url = `${this.rutaServidor}${this.uri}/searchLanguage`;
    this.spinnerService.showAll();
    this.httpParams = this.httpParams.set('employeeId', employeeId.toString());
    return this.httpClient.post<any>(url, null,{params: this.httpParams})
    .pipe(
      tap(response =>{
        this.spinnerService.hideAll();
      })
    );
  }

  
}



// WEBPACK FOOTER //
// ./src/app/core/services/calendar-event.service.ts